import Http from '@/api/request'

/**
 * 发现页面相关接口
 */
export const SongsApi = {
  // 获取banner
  getBannerList (data: { page_size: number; offset: number }) {
    return Http.get(`/v3/banners?page_size=${data.page_size}&offset=${data.offset}`)
  },
  //  首页列表
  getDiscoverList (data: { page_size: number; offset: number; search_txt?: string }) {
    return Http.get(`/v3/music_store_lists`, data)
  },
  // 获取材料详情
  getNotesInfo (params) {
    return Http.get(`/v2/materials/info`, params)
  },
  // 喜欢列表
  apiGetLikeList (params) {
    return Http.get(`/v2/favors`, params)
  },
  // 加入喜欢
  apiJoinLike (data) {
    return Http.post(`/v2/favor/${data.id}`)
  },
  // 取消喜欢
  apiDeleteLike (data) {
    return Http.post(`/v2/batchdelfavor?worksIds=${data.id}`)
  },
  // 评论列表
  apiCommentList (data) {
    return Http.get(`/v3/comments/${data.worksId}`, data)
  },
  // 发送评论
  apiSubmitComment (data) {
    return Http.post(`/v2/comment`, data)
  },
  // 点赞评论
  apiLikeComment (data) {
    return Http.post(`/v2/comment/praise/${data.id}`)
  },
  // 播放音乐记录
  apiPlayMusicAction (data) {
    return Http.post(`/v3/play/${data.id}`)
  },
  // 左右滑动切换音乐（全部）
  getAllBehindMusic (data) {
    return Http.post(`/v1/get_all_behind_music`, data)
  },
  //  左右滑动切换音乐（我喜欢）
  getFavorBehindMusic (data) {
    return Http.post(`/v2/get_favor_behind_music`, data)
  },
  //  根据音乐id获取在音乐全部列表的位置
  getMusicLocation (data) {
    return Http.post(`/v1/get_music_location`, data)
  },
  // 根据id获取在我的喜欢音乐列表的位置
  getFavorMusicLocation (data) {
    return Http.post(`/v2/get_favor_music_location`, data)
  },
  // 音乐评论举报
  commentReport (data) {
    return Http.post(`/v2/comment_report`, data)
  },
  /**
   * 贡献度添加
   * @param music_id
   * @param task_type 1：播放，2：购买，3：分享
   * @returns 
   */
  addMusicContribution (data) {
    return Http.post(`/v2/add_music_contribution`, data)
  },
  // 贡献度详情
  musicContributionInfo (data) {
    return Http.get(`/v3/music_contribution/info`, data)
  },
  // 天使经纪人-歌词后
  musicContributionAngel (data) {
    return Http.get(`/v3/music_contribution/angel`, data)
  },
  // 天使经纪人列表
  musicContributionAngelList (data) {
    return Http.get(`/v3/music_contribution/angel/lists`, data)
  },
  // 藏品贡献度列表
  musicContributionList (data) {
    return Http.get(`/v2/music_contribution/lists`, data)
  },
  // 获取音乐简短信息
  shot_music_info (data) {
    return Http.get(`/v1/shot_music_info`, data)
  },
  /**
   * 获取作品扩展信息-V4.10.0
   * @param data {music_id}
   * @returns 
   */
  get_works_ext_info (data) {
    return Http.get(`/v1/get_works_ext_info`, data)
  },
  // 音乐点赞设置-V4.10.0
  music_great_set (params) {
    return Http.post(`/v1/music_great_set`, params)
  },
  // 音乐点赞获取-V4.10.0
  music_great_get (params) {
    return Http.get(`/v1/music_great_get`, params)
  },
}
